import React, { useEffect } from 'react';

import { CreatePortal } from '../create-portal/create-portal';

interface SpinnerProps {
  show: boolean;
}
const Spinner = ({ show }: SpinnerProps) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add('spinner-backdrop');
    }
    return () => {
      document.body.classList.remove('spinner-backdrop');
    };
  }, [show]);
  return (
    <>
      {show && (
        <CreatePortal>
          <div
            role="status"
            className="fixed left-1/2 top-1/2 z-[100] h-12 w-12 -translate-x-1/2 -translate-y-1/2 transform"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 102 102"
              className="h-12 w-12 animate-spin fill-brand-yellow-1"
            >
              <path
                d="M96.57 39.43c6.31 25.75-9.46 51.74-35.21 58.05S9.63 88.02 3.32 62.27c-.91-3.72-1.37-7.53-1.38-11.36a47.85 47.85 0 0 1 13.57-33.44c4.63-4.75 12.14.83 7.32 6.46-6.46 7.21-11.59 15.87-11.59 26.31 0 22.48 18.22 40.7 40.7 40.7s40.7-18.22 40.7-40.7c0-3.23-.39-6.46-1.15-9.6-.8-3.66 4.1-4.89 5.08-1.21Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        </CreatePortal>
      )}
    </>
  );
};

export default Spinner;
